export default "__VITE_ASSET__DxOp3MNg__"